function MultilanguageHelper() {
    var v = {};

    v.initLangs = function (langs, systemLang) {
        v.langs = langs || {'en': 'English'};
        v.systemLang = systemLang || 'en';
        v.lang = systemLang || 'en';
    };

    v.initStrings = function (obj, fields) {
        if (v.fields) {
            v.fields.forEach(function (item) {
                delete v[item];
            });
        }

        v.obj = obj;
        v.fields = fields;

        v.fields.forEach(function (item) {
            Object.defineProperty(v, item, {
                enumerable: true,
                configurable: true,
                get: function () {
                    if (!v.obj[item]) v.obj[item] = {};
                    return v.obj[item][v.lang];
                },
                set: function (value) {
                    v.obj[item][v.lang] = value;
                }
            });
        });
    };

    v.existsLangs = function () {
        var result = [];
        for (var code in v.langs) {
            result.push(code);
        }

        result.push('az');
        return result;
    };

    v.selected = function (lang) {
        if (lang) v.lang = lang;
        return v.lang;
    };

    // DEPRECATED -- TO BE REMOVED
    v.addLang = function (lang) {
        v.fields.forEach(function (item) {
        });
    };

    return v;
}

function getPOSId(pos_id) {
    if (pos_id)
        return (pos_id.indexOf('POS-') === 0) ? pos_id.substring(4) : pos_id;
    else
        return null;
}

function updateItemInList(list, item) {
    if (!list) return;

    var index = -1;
    for (var i in list) {
        if (list[i].id === item.id) {
            index = i;
            break;
        }
    }

    if (index > -1) {
        list[index] = item;
    } else {
        list.unshift(item);
    }
}

/**
 * Return item from list of object. Object identification by object's field "id"
 * @param list - array of objects
 * @param item_id - item id value
 * @param field - field name for identification
 */
function itemByIndex(list, item_id, field) {
    if (!list || list.length === 0) return null;

    if (!field)
        field = 'id';

    var index = -1;
    for (var i in list) {
        if (list[i][field] && (list[i][field] === item_id || list[i][field].replace(/[-]*/g, '') === item_id)) {
            index = i;
            break;
        }
    }

    if (index > -1) {
        return list[index];
    } else {
        return null;
    }
}

// function _cookiesOptions(secure) {
//     var d = new Date();
//     d.setFullYear(d.getFullYear() + 1);
//     var options = {
//         expires: d
//     };
//
//     if (secure)
//         options.secure = secure
//
//     return options;
// }

function isPhoneValid(phone) {
    if (phone) {
        var isValidPhoneNumber = function (number) {
            try {
                return number ? window.libphonenumber.isValidPhoneNumber(number) : false;
            } catch (e) {
                return false;
            }
        };
        return !!(isValidPhoneNumber(phone) || phone.indexOf('+38011') == 0);
    }

    return false;
}

function getCountryCodeByPhone(phone) {
    if(!phone) {
        return null;
    }
    try {
        var phoneNumber = window.parsePhoneNumber(number);
        return phoneNumber ? phoneNumber.country : null;
    } catch (e) {
        return null;
    }
}


function isEmailValid(email) {
    if (email) {
        var mail_regex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/);
        if (mail_regex.test(email))
            return true;
        else
            return false;
    } else {
        return false;
    }
}

function isURLValid(url) {
    var URL_REGEXP = /^(http|https):\/\/[^ "]+$/;
    if (URL_REGEXP.test(url))
        return true;
    else
        return false;
}

/**
 * DEPRECATED
 * Format datetime to UTC string like
 * @param date
 */
function dtFormat(date) {
    return moment(date).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
}

function dateFieldsFormat(data, src, dst, utc) {
    for (var i in data)
        if (moment(data[i], src ? src : 'YYYY-MM-DD[T]HH:mm:ss[Z]', true).isValid()) {
            if (!!utc) {
                data[i] = dst ? moment(data[i]).utc().format(dst) : moment(data[i]).toDate();
            } else {
                data[i] = dst ? moment(data[i]).format(dst) : moment(data[i]).toDate();
            }
        }

    return data;
}

function cleanRequestData(data, ignoreFields) {
    for (var i in data) {
        if (ignoreFields && ignoreFields.indexOf(i) > -1)
            continue;

        if (data[i] === null)
            delete data[i];
    }

    return data;
}

// function paramsToUrlQuery(params, delimiter) {
//     var result = '';
//     delimiter = delimiter || '&';
//     for (var name in params) {
//         if (params[name] && name !== 'readed') {
//             if (result) result = result + delimiter;
//             result = result + "{0}={1}".format(name, params[name]);
//         } else {
//             if (name == 'readed' && params[name] === false) {
//                 if (result) result = result + delimiter;
//                 result = result + name + '=' + params[name];
//             }
//         }
//     }
//     return result;
// }

function paramsToUrlQueryEncodeURIComponent(params, delimiter) {
    var result = '';
    delimiter = delimiter || '&';
    for (var name in params) {
        if (params[name] && name !== 'readed') {
            if (result) result = result + delimiter;
            result = result + '{0}={1}'.format(name, encodeURIComponent(params[name]));
        } else {
            if (params[name] === false) {
                if (result) result = result + delimiter;
                result = result + name + '=' + (params[name]);
            }
        }
    }
    return result;
}

function intToHEX(num) {
    return num.toString(16).substring(0, 6);
}

function hexToInt(color) {
    return parseInt(color + 'ff', 16);
}

function imgToDataUrl(url, callback) {
    var image = new Image();

    image.setAttribute('crossOrigin', 'anonymous');

    image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
        canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

        canvas.getContext('2d').drawImage(this, 0, 0);

        // Get raw image data
        // callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

        // ... or get as Data URI
        var data = null;
        if (url.indexOf('.png') > -1) {
            data = canvas.toDataURL('image/png');
        } else {
            data = canvas.toDataURL('image/jpeg', 0.9);
        }
        callback(data);
    };

    image.src = url;
}

function getLocalizedPath(country, lang) {
    if (country && lang)
        if (country == 'UA')
            return 'ua';
        else if (country == 'RU')
            return 'ru';
        else if (lang == 'ru' && country != 'UA')
            return 'ru';
        else
            return 'en';
    else
        return 'en';
}

function getLocalizedPathFromLang(lang) {
    if (!lang)
        return 'en';

    if (lang == 'uk')
        return 'ua';

    if (lang == 'pl')
        return 'pl';

    if (lang == 'ru')
        return 'ru';

    if (lang == 'az')
        return 'az';

    return 'en';
}

function getLocalizedPathFromUrlByLang(url, lang) {
    var localized_url_key = 'en';
    var localized_url = 'en';

    if (lang === undefined || lang === null || !lang) {
        localized_url_key = 'en';
    } else {
        localized_url_key = lang.toLowerCase();
    }

    if (typeof url === 'object') {
        if (!url.hasOwnProperty(localized_url_key)) {
            localized_url_key = 'en';
        }

        localized_url = url[localized_url_key];
    } else {
        localized_url = url;
    }

    return localized_url;
}

function isFormValid(form) {
    var hasErrors;
    if (form.$invalid) {
        for (var i in form) {

            if (form[i] && form[i].hasOwnProperty('$dirty')) {
                form[i].$dirty = true;
                if (form[i].$invalid && !hasErrors) {
                    console.log('$invalid', form[i])
                    hasErrors = i;
                    var tf = document.getElementsByName(form[i].$name)[0];
                    if (tf && tf.attributes['ng-model'] && tf.attributes['ng-model'].value == 'html') {
                        tf = tf.parentElement;
                    }

                    var elTop = angular.element(tf).offset().top || (!!tf.parentElement ? angular.element(tf.parentElement).offset().top : 0);

                    if (elTop > 0) {
                        $('html,body').animate({scrollTop: elTop - 200}, 'fast');

                        tf.focus();
                    }

                }
            }
        }
    }

    if (hasErrors)
        return false;
    else
        return true;
}

function isFormValidInModal(form) {
    var hasErrors;
    if (form.$invalid) {
        for (var i in form) {

            if (form[i] && form[i].hasOwnProperty('$dirty')) {
                form[i].$dirty = true;

                if (form[i].$invalid && !hasErrors) {
                    hasErrors = i;
                    var tf = document.getElementsByName(form[i].$name)[0];
                    var elTop = angular.element(tf).offset().top;

                    $('.modal.in').animate({scrollTop: elTop - 200}, 'fast');

                    tf.focus();
                }

            }
        }
    }

    if (hasErrors)
        return false;
    else
        return true;
}

function getLocalizeField(field, lang) {
    if (!lang)
        lang = 'en';

    if (field) {
        var f;
        if (typeof field === 'object') {
            f = field;
        } else if (typeof field === 'string') {
            try {
                f = JSON.parse(field);
            } catch (e) {

            }
        }

        if (f)
            if (f[lang])
                return f[lang];
            else
                for (var i in f)
                    return f[i];
        else
            return field;

    } else {
        return '';
    }
};

function getTotalPaginatedPages(arg) {
    if (!arg)
        return '-';

    return Math.ceil(arg);
}

function getPrefferedLang(langs, lang) {
    for (var i in langs)
        if (i === lang)
            return i;
    return 'en';
}

function getFirstActive(list) {
    if (list && list.length > 0) {
        for (var i in list)
            if (list[i].active === 1)
                return list[i];

        return list[0];
    }

    return null;
}

function saveJSONToFile(file_name, data) {
    var json = angular.toJson(data, true),
        blob = new Blob([json], {
            type: 'application/json;charset=utf-8;'
        }),
        dl = document.createElement('a');

    dl.setAttribute('download', file_name + '.txt');
    dl.setAttribute('href', window.URL.createObjectURL(blob));
    dl.click();
}

String.prototype.format = String.prototype.f = function () {
    var args = arguments;
    return this.replace(/\{(\d+)\}/g, function (m, n) {
        return args[n] ? args[n] : '';
    });
};

// function roughSizeOfObject( object ) {

//     var objectList = [];
//     var stack = [ object ];
//     var bytes = 0;

//     while ( stack.length ) {
//         var value = stack.pop();

//         if ( typeof value === 'boolean' ) {
//             bytes += 4;
//         }
//         else if ( typeof value === 'string' ) {
//             bytes += value.length * 2;
//         }
//         else if ( typeof value === 'number' ) {
//             bytes += 8;
//         }
//         else if
//         (
//             typeof value === 'object'
//             && objectList.indexOf( value ) === -1
//         )
//         {
//             objectList.push( value );

//             for( var i in value ) {
//                 stack.push( value[ i ] );
//             }
//         }
//     }
//     return bytes;
// }
function doubleScroll(element) {
    // if (!element || element.classList.contains("init-doubleScroll")) {
    //     return;
    // }
    var scrollbar = document.createElement('div');
    scrollbar.appendChild(document.createElement('div'));
    scrollbar.style.overflow = 'auto';
    scrollbar.style.overflowY = 'hidden';
    scrollbar.firstChild.style.width = element.scrollWidth + 'px';
    scrollbar.firstChild.style.paddingTop = '1px';
    scrollbar.firstChild.appendChild(document.createTextNode('\xA0'));
    var running = false;
    scrollbar.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
    };
    element.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
    };
    element.parentNode.insertBefore(scrollbar, element);
    element.classList.add('init-doubleScroll');
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item) {
    return item && (typeof item === 'undefined' ? 'undefined' : typeof item) === 'object' && !Array.isArray(item);
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {value: value, enumerable: true, configurable: true, writable: true});
    } else {
        obj[key] = value;
    }
    return obj;
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function mergeDeep(target) {
    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
    }

    if (!sources.length) return target;
    var source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, _defineProperty({}, key, source[key]));
            }
        }
    }

    return mergeDeep.apply(undefined, [target].concat(sources));
}

function flattenMenu(menu, subProp) {
    var result = [];
    menu.forEach(function (item) {
        result.push(item);
        if (subProp && item[subProp]) {
            result = result.concat(flattenMenu(item[subProp], subProp));
        }
    });
    return result;
}

function deepMap(list, callbackFn, subProp) {
    return (list || []).map(function (item) {
        item = callbackFn(item);
        if (subProp && item[subProp]) {
            deepMap(item[subProp], callbackFn, subProp);
        }
        return item;
    });
}

function deepFind(list, subProp) {

}
